import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getHeaders } from "./getHeaders";

export const getNoftfications = createAsyncThunk(
  "Home/getNoftfications",
  async ({ page = 1, only_not_read = 1 } = {}, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const params = { page };
      if (only_not_read === 1) {
        params.only_not_read = 1;
      }

      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/notifications`, {
          headers: getHeaders(),
          params,
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
// updateNotifications
export const updateNotifications = createAsyncThunk(
  "Home/updateNotifications",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/notifications/${id}/mark-as-read`,
          {},
          {
            headers: getHeaders(),
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const SendNotfications = createAsyncThunk(
  "Home/SendNotfications",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/send-notifications`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getContact = createAsyncThunk(
  "Home/getContact",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/contactus`, {
          headers: getHeaders(),
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sendAsnwer = createAsyncThunk(
  "Home/sendAsnwer",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/contactus/${data.id}/update`,
          data,
          {
            headers: getHeaders(),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const DeleteAsnwer = createAsyncThunk(
  "Product/DeleteAsnwer",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/contactus/${id}`,
        {
          headers: getHeaders(),
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getDriverContact = createAsyncThunk(
  "Home/getDriverContact",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/driver_contactus`, {
          headers: getHeaders(),
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sendDriverAsnwer = createAsyncThunk(
  "Home/sendDriverAsnwer",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/driver_contactus/${data.id}/update`,
          data,
          {
            headers: getHeaders(),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const DeleteDriverAsnwer = createAsyncThunk(
  "Product/DeleteDriverAsnwer",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/driver_contactus/${id}`,
        {
          headers: getHeaders(),
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getFAQByIDRequest = createAsyncThunk(
  "Home/getFAQByIDRequest",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/faqs/${id}`, {
          headers: getHeaders(),
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getFAQ = createAsyncThunk("Home/getFAQ", async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const data = await axios
      .get(`${process.env.REACT_APP_BACKEND_API}api/admin/faqs`, {
        headers: getHeaders(),
      })
      .then((res) => res.data);
    return data;
  } catch (err) {
    return rejectWithValue(err.response.data);
  }
});

export const addFAQ = createAsyncThunk(
  "Product/addFAQ",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/admin/faqs`, data, {
          headers: getHeaders(true),
        })
        .then((res) => res.data);

      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const EditFAQ = createAsyncThunk(
  "Product/EditFAQ",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/faqs/${data.id}/update`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);

      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteFAQ = createAsyncThunk(
  "Product/deleteFAQ",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/admin/faqs/${id}`,
        {
          headers: getHeaders(),
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getSetting = createAsyncThunk(
  "Home/getSetting",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/settings`, {
          headers: getHeaders(),
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const addSetting = createAsyncThunk(
  "Home/addSetting",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(`${process.env.REACT_APP_BACKEND_API}api/admin/settings`, data, {
          headers: getHeaders(true),
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateSetting = createAsyncThunk(
  "Home/updateSetting",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/settings/${data.id}/update`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getLogs = createAsyncThunk(
  "Home/getLogs",
  async (page, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/log-activities`, {
          headers: getHeaders(),
          params: {
            page,
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getResturantLogs = createAsyncThunk(
  "Home/getResturantLogs",
  async (page, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/admin/restaurant-log-activities`,
          {
            headers: getHeaders(),
            params: {
              page,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const HomeSlice = createSlice({
  name: "Home",
  initialState: {
    isHomeLoading: false,
    error: null,
    NotificationsArr: null,
    NotificationsMeta: null,
    NotificationsTotalUnread: 0,
    NotificationsAllArr: null,
    NotificationsAllMeta: null,
    ContactArray: null,
    DriverContactArray: null,
    FAQArray: null,
    FAQByIDArray: null,
    SettingsArray: null,
    LogsArray: null,
    ResturantLogsArray: null,
  },
  reducers: {
    SetNoftficationsPusher: (state, action) => {
      if (!state.NotificationsArr) {
        state.NotificationsArr = []; // تأكد من أنها ليست null
      }

      state.NotificationsArr.unshift(action.payload);
    },
  },
  extraReducers: {
    [getNoftfications.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [getNoftfications.fulfilled]: (state, action) => {
      const args = action.meta.arg || {};
      state.NotificationsTotalUnread = action.payload.data.total_unread;
      if (args.only_not_read === 0) {
        state.NotificationsAllArr = action.payload.data.data;
        state.NotificationsAllMeta = action.payload.data.meta;
      } else {
        state.NotificationsArr = action.payload.data.data;
        state.NotificationsMeta = action.payload.data.meta;
      }
      state.isHomeLoading = false;
    },
    [getNoftfications.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
    [SendNotfications.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [SendNotfications.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
    },
    [SendNotfications.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },

    // updateNotifications
    [updateNotifications.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [updateNotifications.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
      const id = action.meta.arg;
      if (state.NotificationsArr) {
        state.NotificationsArr = state.NotificationsArr.map((notification) =>
          notification.id === id
            ? { ...notification, status: "read" }
            : notification,
        );
      }
      if (state.NotificationsAllArr) {
        state.NotificationsAllArr = state.NotificationsAllArr.map(
          (notification) =>
            notification.id === id
              ? { ...notification, status: "read" }
              : notification,
        );
      }
      if (typeof state.NotificationsTotalUnread === "number") {
        state.NotificationsTotalUnread = Math.max(
          0,
          state.NotificationsTotalUnread - 1,
        );
      }
    },
    [updateNotifications.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
    [getContact.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [getContact.fulfilled]: (state, action) => {
      state.ContactArray = action.payload.data;
      state.isHomeLoading = false;
    },
    [getContact.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
    // sendAsnwer
    [sendAsnwer.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [sendAsnwer.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
    },
    [sendAsnwer.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
    // DeleteAsnwer
    [DeleteAsnwer.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [DeleteAsnwer.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
      state.ContactArray = state.ContactArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteAsnwer.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },

    [getDriverContact.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [getDriverContact.fulfilled]: (state, action) => {
      state.DriverContactArray = action.payload.data;
      state.isHomeLoading = false;
    },
    [getDriverContact.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
    // sendDriverAsnwer
    [sendDriverAsnwer.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [sendDriverAsnwer.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
    },
    [sendDriverAsnwer.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
    // DeleteDriverAsnwer
    [DeleteDriverAsnwer.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [DeleteDriverAsnwer.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
      state.DriverContactArray = state.DriverContactArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
    },
    [DeleteDriverAsnwer.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },

    [getFAQByIDRequest.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [getFAQByIDRequest.fulfilled]: (state, action) => {
      state.FAQByIDArray = action.payload.data;
      state.isHomeLoading = false;
    },
    [getFAQByIDRequest.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },

    // getFAQ
    [getFAQ.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [getFAQ.fulfilled]: (state, action) => {
      state.FAQArray = action.payload.data;
      state.isHomeLoading = false;
    },
    [getFAQ.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },

    [addFAQ.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [addFAQ.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
    },
    [addFAQ.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
    [EditFAQ.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [EditFAQ.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
    },
    [EditFAQ.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
    [deleteFAQ.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [deleteFAQ.fulfilled]: (state, action) => {
      state.FAQArray = state.FAQArray.filter(
        (ele) => ele.id !== action.meta.arg
      );
      state.isHomeLoading = false;
    },
    [deleteFAQ.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },

    [getSetting.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [getSetting.fulfilled]: (state, action) => {
      state.SettingsArray = action.payload.data;
      state.isHomeLoading = false;
    },
    [getSetting.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
    [addSetting.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [addSetting.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
    },
    [addSetting.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
    [updateSetting.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [updateSetting.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
    },
    [updateSetting.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },

    [getLogs.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [getLogs.fulfilled]: (state, action) => {
      state.LogsArray = action.payload;
      state.isHomeLoading = false;
    },
    [getLogs.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
    [getResturantLogs.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [getResturantLogs.fulfilled]: (state, action) => {
      state.ResturantLogsArray = action.payload;
      state.isHomeLoading = false;
    },
    [getResturantLogs.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },
  },
});
export const { SetNoftficationsPusher } = HomeSlice.actions;

export default HomeSlice.reducer;
